import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";
import Layout from "@/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";

import Accueil from "@/pages/Accueil";
import APropos from "@/pages/APropos";
import Services from "@/pages/Services";
import Galerie from "@/pages/Galerie";
import Menus from "@/pages/Menus";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminContent from "@/pages/AdminContent";
import AdminReviews from "@/pages/AdminReviews";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-kayama-cream text-kayama-brown-2">
                Chargement…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function PublicRoutes() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Accueil />} />
                <Route path="/a-propos" element={<APropos />} />
                <Route path="/services" element={<Services />} />
                <Route path="/galerie" element={<Galerie />} />
                <Route path="/menus" element={<Menus />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Layout>
    );
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/content"
                element={
                    <ProtectedRoute>
                        <AdminContent />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/reviews"
                element={
                    <ProtectedRoute>
                        <AdminReviews />
                    </ProtectedRoute>
                }
            />
            <Route path="/*" element={<PublicRoutes />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ContentProvider>
                        <ScrollToTop />
                        <AppRoutes />
                        <Toaster position="top-right" richColors />
                    </ContentProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
